// extracted by mini-css-extract-plugin
export default {"desktopTaxFeeContainer":"YuzL_b","mobileTaxFeeContainer":"IT1Mwn"};